import Vue from "vue";

export const updateLogin = (state, {prop, value}) => {
  state.login[prop] = value;
};

export const updateRegistration = (state, {prop, value}) => {
  Vue.set(state.registration, prop, value);
};